import styled from "styled-components";
import { CarouselHeaderSlider } from "../../styled.js";
export const CarouselHeaderMobileSlider = styled(CarouselHeaderSlider).withConfig({
    displayName: "styled__CarouselHeaderMobileSlider",
    componentId: "sc-e15f6406-0"
})`
	height: auto;

	.splide__pagination {
		top: ${({ $variant  })=>$variant === 'top' ? '20px' : 'auto'};
		bottom: ${({ $variant  })=>$variant === 'top' ? 'auto' : '10px'};
	}
`;

//# sourceMappingURL=styled.js.map